import React from 'react';
import {useLocalization} from 'localization';
import type {Company} from 'services/companies';
import {CopyToClipboard, FlexBox, Spacer} from 'components';
import {useTextLabel, useTextValue} from 'schema/preview/hooks';

const ContactItem = ({value}: {value: string}) => {
  return (
    <FlexBox horizontal left center>
      <CopyToClipboard text={value} size={'small'} />
      <FlexBox sx={{overflowWrap: 'anywhere'}}>{value}</FlexBox>
    </FlexBox>
  );
};

export const ContactSubPanel = (company: Company) => {
  const {t} = useLocalization();
  const TextValue = useTextValue();
  const TextLabel = useTextLabel();

  const publisherReminderBookEmails = (
    company.publisherReminderBookEmails ?? []
  ).filter(a => a && a !== company.contactInfoEmail);

  const publisherReminderOtherEmails = (
    company.publisherReminderEmails ?? []
  ).filter(a => a && a !== company.contactInfoEmail);

  return (
    <>
      {company.contactInfoEmail && (
        <>
          <TextValue>
            <TextLabel>
              {t(`page.metadata.manifestation.contact.email`)}
            </TextLabel>
            <Spacer width={0.5} />
            <ContactItem value={company.contactInfoEmail} />
          </TextValue>
          <Spacer size={1} />
        </>
      )}

      {publisherReminderBookEmails.length > 0 && (
        <>
          <TextValue>
            <TextLabel>
              {t(`page.metadata.manifestation.contact.book`)}
            </TextLabel>
            <Spacer width={0.5} />
            {publisherReminderBookEmails.map(e => (
              <ContactItem key={e} value={e} />
            ))}
          </TextValue>
          <Spacer size={1} />
        </>
      )}

      {publisherReminderOtherEmails.length > 0 && (
        <>
          <TextValue>
            <TextLabel>
              {t(`page.metadata.manifestation.contact.otherTasks`)}
            </TextLabel>
            <Spacer width={0.5} />
            {publisherReminderOtherEmails.map(e => (
              <ContactItem key={e} value={e} />
            ))}
          </TextValue>
          <Spacer size={1} />
        </>
      )}
    </>
  );
};
